import React from 'react'
import { useRouter } from 'next/router'

import { useToast } from '@wartek-id/toast'

import {
  useQueryAPIGetKSInvitationDocuments,
  useQueryAPIGetKSSelectionCandidate,
  useMutateAPIFinalizeSubmission,
} from 'api/bcks/useAPIBCKSInvitation'
import { SELECTION_STATES_FINAL_PAGE } from '../constants'

type DocumentDataType = {
  title: string
  fileUrl: string
  thumbnailUrl: string
  name: string
}

export function useBCKSInvitationReview() {
  const router = useRouter()
  const { data: selectionState, remove: removeCacheCandidate } =
    useQueryAPIGetKSSelectionCandidate()
  const { data: userDocument } = useQueryAPIGetKSInvitationDocuments(
    selectionState?.selectionId
  )
  const finalizedSubmissionMutation = useMutateAPIFinalizeSubmission(
    selectionState?.selectionId
  )

  if (
    selectionState &&
    SELECTION_STATES_FINAL_PAGE.includes(
      selectionState?.selectionCandidateState
    )
  ) {
    router.replace('/bcks/invitation/final')
  }

  const toast = useToast()
  const [sheetOpen, setSheetOpen] = React.useState(false)
  const [sheetType, setSheetType] = React.useState('confirm')

  const mapDocumentFromAPItoDocumentData = () => {
    const documentKeyMap = {
      kinerja: {
        title: 'Hasil Penilaian Kinerja',
        fileUrl: userDocument?.hasilPenilaianKinerjaUrl,
        thumbnailUrl: userDocument?.hasilPenilaianKinerjaThumbnailUrl,
      },
      police: {
        title: 'Surat Keterangan Catatan Kepolisian',
        fileUrl: userDocument?.catatanKepolisianUrl,
        thumbnailUrl: userDocument?.catatanKepolisianThumbnailUrl,
      },
      managerial: {
        title: 'Surat Keterangan Pengalaman Manajerial',
        fileUrl: userDocument?.pengalamanManajerialUrl,
        thumbnailUrl: userDocument?.pengalamanManajerialThumbnailUrl,
      },
      health: {
        title: 'Surat Keterangan Kesehatan',
        fileUrl: userDocument?.kesehatanUrl,
        thumbnailUrl: userDocument?.kesehatanThumbnailUrl,
      },
      discipline: {
        title: 'Surat Keterangan Atasan Bebas Hukuman',
        fileUrl: userDocument?.bebasHukumanUrl,
        thumbnailUrl: userDocument?.bebasHukumanThumbnailUrl,
      },
    }

    return documentKeyMap
  }

  const handleChangeDocument = (documentData: DocumentDataType) => {
    const { name, fileUrl, title } = documentData

    router.push(
      `/bcks/invitation/collection?docTitle=${title}&docName=${name}&docUrl=${fileUrl}`
    )
  }

  const handleFinalizedDocument = () => {
    finalizedSubmissionMutation.mutate(
      {},
      {
        onSuccess: () => {
          toast({
            message: `Berhasil Finalisasi Dokumen Seleksi`,
          })
          setSheetType('success')
        },
        onError: () => {
          toast({
            message: `Gagal! Silahkan cek dokumen seleksi atau hubungi tim kami`,
          })
          setSheetOpen(false)
        },
      }
    )
  }

  const handleNextStep = () => {
    removeCacheCandidate()
    router.replace('/bcks/invitation/final')
  }

  const handleSaveDraft = () => {
    toast({
      message: `Draf telah tersimpan`,
    })
    setSheetType('success')
    router.replace('/bcks/invitation/precollection')
  }

  return {
    documentData: mapDocumentFromAPItoDocumentData(),
    handleChangeDocument,
    handleFinalizedDocument,
    sheetType,
    sheetOpen,
    setSheetOpen,
    setSheetType,
    handleSaveDraft,
    handleNextStep,
  }
}
